import { useData } from 'vike-react/useData'
import type { Data } from './+data'
import ProductDetailView from '../../src/ssr/product/ProductDetailView'
import { resolveVariant } from '../../src/ssr/product/resolveVariant'
import ProductSeoHead from '../../src/ssr/product/ProductSeoHead'
import { isFullVariantArray } from '../../src/ssr/product/variantGuards'
import type { Variant } from '../../src/types'

export default function ProductVariantPage() {
  const { lang, product, variantSlug, related, distributor_offers } = useData<Data>()
  const variants: Variant[] = isFullVariantArray(product.variants) ? product.variants : []
  const resolved = resolveVariant(variants, variantSlug)

  return (
    <>
      <ProductSeoHead
        lang={lang}
        product={product}
        variant={resolved.variant}
        variants={variants}
        isCanonicalPage={false}
      />
      <ProductDetailView
        lang={lang}
        product={product}
        variants={variants}
        selected={resolved.variant}
        related={related}
        distributorOffers={distributor_offers}
      />
    </>
  )
}
